import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const MultipleBlogPosts = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <g filter="url(#filter0_d_4895_104356)">
          <path
            d="M5.30869 6C5.30869 4.89543 6.20412 4 7.30869 4H21.3087C22.4133 4 23.3087 4.89543 23.3087 6V20C23.3087 21.1046 22.4133 22 21.3087 22H7.30869C6.20412 22 5.30869 21.1046 5.30869 20V6Z"
            fill="#E9E9E9"
          />
        </g>
        <path
          d="M5.30869 5.90485C5.30869 4.80028 6.20412 3.90485 7.30869 3.90485H21.3087C22.4133 3.90485 23.3087 4.80028 23.3087 5.90485V12H5.30869V5.90485Z"
          fill="#D2862E"
        />
        <g filter="url(#filter1_d_4895_104356)">
          <path
            d="M2.30869 3C2.30869 1.89543 3.20412 1 4.30869 1H18.3087C19.4133 1 20.3087 1.89543 20.3087 3V17C20.3087 18.1046 19.4133 19 18.3087 19H4.30869C3.20412 19 2.30869 18.1046 2.30869 17V3Z"
            fill="white"
          />
        </g>
        <path
          d="M4.49619 11.9405C4.49619 11.6644 4.72004 11.4405 4.99619 11.4405H17.6212C17.8973 11.4405 18.1212 11.6644 18.1212 11.9405C18.1212 12.2167 17.8973 12.4405 17.6212 12.4405H4.99619C4.72004 12.4405 4.49619 12.2167 4.49619 11.9405Z"
          fill="black"
          fillOpacity="0.4"
        />
        <path
          d="M4.49619 14.2405C4.49619 13.9644 4.72004 13.7405 4.99619 13.7405H17.6212C17.8973 13.7405 18.1212 13.9644 18.1212 14.2405C18.1212 14.5167 17.8973 14.7405 17.6212 14.7405H4.99619C4.72004 14.7405 4.49619 14.5167 4.49619 14.2405Z"
          fill="black"
          fillOpacity="0.4"
        />
        <path
          d="M4.49619 16.5405C4.49619 16.2644 4.72004 16.0405 4.99619 16.0405H11.3237C11.5998 16.0405 11.8237 16.2644 11.8237 16.5405C11.8237 16.8167 11.5998 17.0405 11.3237 17.0405H4.99619C4.72004 17.0405 4.49619 16.8167 4.49619 16.5405Z"
          fill="black"
          fillOpacity="0.4"
        />
        <path
          d="M2.30869 3C2.30869 1.89543 3.20412 1 4.30869 1H18.3087C19.4133 1 20.3087 1.89543 20.3087 3V9.46875H2.30869V3Z"
          fill="url(#paint0_linear_4895_104356)"
        />
        <g filter="url(#filter2_d_4895_104356)">
          <path
            d="M4.49619 4.04719C4.49619 3.63367 4.83141 3.29845 5.24493 3.29845H17.3724C17.786 3.29845 18.1212 3.63367 18.1212 4.04719C18.1212 4.46071 17.786 4.79594 17.3724 4.79594H5.24493C4.83141 4.79594 4.49619 4.46071 4.49619 4.04719Z"
            fill="white"
            fillOpacity="0.78"
            shapeRendering="crispEdges"
          />
        </g>
        <g filter="url(#filter3_d_4895_104356)">
          <path
            d="M4.49619 6.8707C4.49619 6.45717 4.83141 6.12195 5.24493 6.12195H14.7482C15.1617 6.12195 15.4969 6.45717 15.4969 6.8707C15.4969 7.28422 15.1617 7.61944 14.7482 7.61944H5.24493C4.83141 7.61944 4.49619 7.28422 4.49619 6.8707Z"
            fill="white"
            fillOpacity="0.78"
            shapeRendering="crispEdges"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_4895_104356"
            x="3.30869"
            y="3"
            width="22"
            height="22"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4895_104356" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4895_104356" result="shape" />
          </filter>
          <filter
            id="filter1_d_4895_104356"
            x="0.308685"
            y="0"
            width="22"
            height="22"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4895_104356" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4895_104356" result="shape" />
          </filter>
          <filter
            id="filter2_d_4895_104356"
            x="3.49619"
            y="3.29845"
            width="15.625"
            height="3.49749"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="0.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4895_104356" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4895_104356" result="shape" />
          </filter>
          <filter
            id="filter3_d_4895_104356"
            x="3.49619"
            y="6.12195"
            width="13.0007"
            height="3.49749"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="0.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4895_104356" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4895_104356" result="shape" />
          </filter>
          <linearGradient
            id="paint0_linear_4895_104356"
            x1="11.3087"
            y1="1"
            x2="11.3087"
            y2="9.46875"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBF19" />
            <stop offset="1" stopColor="#E27A00" />
          </linearGradient>
        </defs>
      </svg>
    )
  },
)

export default MultipleBlogPosts
